/**
 * @file aiSearchConnector.js
 * @description Manages communication with the secure AI backend worker.
 * @version 1.0.0
 */

class AiSearchConnector {
    constructor() {
        // IMPORTANT: Make sure this is your correct worker URL
        this.workerUrl = 'https://cyberos-ai-proxy.cyberosaiproxy.workers.dev';
        
        if (AiSearchConnector._instance) {
            return AiSearchConnector._instance;
        }
        AiSearchConnector._instance = this;
    }

    /**
     * Sends a query to the secure AI worker and returns the response.
     * @param {string} promptText The user's query from the terminal.
     * @returns {Promise<string>} The AI's formatted HTML response.
     */
    async query(promptText) {
        if (!promptText || typeof promptText !== 'string') {
            throw new Error('Invalid query text.');
        }

        try {
            const response = await fetch(this.workerUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: promptText,
                }),
            });

            if (!response.ok) {
                // Try to parse the error from the worker
                let errorMsg = `API Error (${response.status})`;
                try {
                    const errorData = await response.json();
                    errorMsg = `API Error (${response.status}): ${errorData.error || 'Unknown'}`;
                } catch (e) {
                    // Fallback if the error response isn't JSON
                    errorMsg = `API Error (${response.status}): ${response.statusText}`;
                }
                throw new Error(errorMsg);
            }

            const data = await response.json();
            return data.answer; // This will be the HTML string from the AI

        } catch (error) {
            console.error('[AiSearchConnector] Error:', error);
            throw new Error(`Connection failed: ${error.message}`);
        }
    }
}

// Create and export the singleton instance
const AiSearchConnectorInstance = new AiSearchConnector();
export default AiSearchConnectorInstance;